/**
 * Which sidekick agent tabs the sidebar offers.
 *
 * ── Review QA is HIDDEN, not deleted ────────────────────────────────────────
 * The reviewer agents (GT CTS, MMGY DV360/TTD) and their whole stack — the
 * hooks (useGtCtsReviewerSession, useMmgyClwReviewerSession), the backend routes
 * (gtCtsReviewerSessions, mmgyClwReviewerSessions), the services, the suggestion
 * chips in AgentSidebar — are all still wired and still work. Only the TAB that
 * reaches them is withheld, from one flag, so turning the feature back on is
 * flipping this constant rather than reconstructing the surface.
 *
 * Two consequences worth knowing before flipping it:
 *   · Hosts still build their reviewer sessions. They are gated on
 *     `agentMode === 'qa'`, which can no longer be selected, so nothing
 *     auto-starts and no session is created — the cost of leaving them wired is
 *     the hook call, not an agent run.
 *   · Hosts also normalise `agentMode` off this flag, so a persisted or
 *     deep-linked 'qa' mode falls back rather than rendering a sidebar with no
 *     agent behind it.
 */
// Demo 0820: a reviewer typed "please QA this campaign" and nothing happened.
// With this false the Review QA tab was never rendered, the GT reviewer session
// never auto-started, and the typed message fell through to the bulk editor —
// whose prompt told the user to switch to a tab that was not on screen. The
// reviewer session, its route, its prompts and its auto-QA copy were all intact
// the whole time; only this flag stood between them and the user.
export const QA_AGENT_TAB_ENABLED = true;

/** The bulk editor — the default tab on every surface that has one. */
export const BULK_TAB = {
  key: 'bulk',
  label: 'Bulk edit',
  title: 'Change dates, budgets and geo across many rows at once',
};

/**
 * Campaign run history — optimizer + edit runs for the current campaign.
 * This tab replaced the Runs tab of the Campaign Grid's removed detail panel.
 */
export const RUNS_TAB = {
  key: 'runs',
  label: 'Runs',
  title: 'Optimizer and edit run history for this campaign',
};

/**
 * Is `mode` a tab the user can currently be on? Hosts call this to normalise
 * state that predates a flag change (or a platform swap under a mounted pane).
 */
export function isSelectableMode(mode) {
  if (mode === 'qa') return QA_AGENT_TAB_ENABLED;
  return mode === 'bulk' || mode === 'optimize' || mode === 'runs';
}

export default { QA_AGENT_TAB_ENABLED, BULK_TAB, RUNS_TAB, isSelectableMode };
